<template>
  <ExpedienteDetailCard :loading="loading" :case-file="caseFile" :judge="entry.user" :title="`Expediente: ${title}`"
                        :pdfURL="entry.pdf">
    <v-card class="mt-1 px-3 custom-font-regular">
      <component :is="entryComponent" :entry="entry"></component>
    </v-card>
    <GoBackButton/>
  </ExpedienteDetailCard>
</template>

<script>
import ExpedienteDetailCard from '../components/ExpedienteDetailCard'
import ExpedienteEntryApertura from '../components/ExpedienteEntryApertura'
import ExpedienteEntryResolucion from '../components/ExpedienteEntryResolucion'
import ExpedienteEntryDescargo from '../components/ExpedienteEntryDescargo'
import ExpedienteEntryApelacion from '../components/ExpedienteEntryApelacion'
import GoBackButton from '../../../common/ui/GoBackButton'

export default {
  components: {
    ExpedienteDetailCard,
    ExpedienteEntryApertura,
    ExpedienteEntryResolucion,
    ExpedienteEntryDescargo,
    ExpedienteEntryApelacion,
    GoBackButton
  },

  data () {
    return {
      loading: false,
      entry: {}
    }
  },

  computed: {
    entryComponent () {
      return `ExpedienteEntry${this.capitalize(this.$route.params.type)}`
    },
    caseFile () {
      return (this.entry.hasOwnProperty('caseFile')) ? this.entry.caseFile : {}
    },
    title () {
      let title = this.$route.params.type
      if (title === 'comite') {
        return 'resolución'
      }
      if (title === 'tribunal') {
        return 'resolución final'
      }
      if (title === 'apelacion') {
        return 'apelación'
      }
      return title
    }
  },

  methods: {
    fetchData () {
      this.loading = true
      this.axios
        .get(`case_file/entry/${this.$route.params.id}`)
        .then(response => {
          this.entry = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    capitalize (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },

  mounted () {
    this.fetchData()
  }
}
</script>
